import { apiGet, apiPost, apiPut, apiDelete, apiPostForm } from './client';

export const auctionGet = (path) => apiGet(`/auction${path}`);
export const saveLot = (id, data) => id ? apiPut(`/auction/lots/${id}`, data) : apiPost('/auction/lots', data);
export const lotAction = (id, data) => apiPost(`/auction/lots/${id}/actions`, data);
export const placeBid = (id, data) => apiPost(`/auction/lots/${id}/bids`, data);
export const bulkAction = (ids, action) => apiPost('/auction/bulk-actions', { lot_ids: ids, action });
export const assignManager = (id, remove = false) => remove ? apiDelete(`/auction/managers/${id}`) : apiPut(`/auction/managers/${id}`, {});
export const adjustBalance = (id, data) => apiPost(`/auction/accounts/${id}/adjust`, data);
export const importLots = (file) => { const body = new FormData(); body.append('file', file); return apiPostForm('/auction/import', body); };
export async function downloadAuction(path, filename) {
  const blob = await apiGet(`/auction/${path}`, { raw: true });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a'); link.href = url; link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export async function uploadAuctionImage(file) {
  if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024) throw new Error('Нужен JPG, PNG или WebP до 5 МБ.');
  const upload = await apiPost('/auction/images/upload-url', { filename: file.name, content_type: file.type, content_length: file.size });
  const response = await fetch(upload.upload_url, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
  if (!response.ok) throw new Error('Не удалось загрузить фото. Попробуйте ещё раз.');
  return upload.media_url;
}
